var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M271.1 176H48.08c-42.63 0-64.25 51.77-33.88 81.9l111.9 112c18.63 18.76 49.13 18.76 67.88 0l112-112c29.12-30.1 8.72-81.9-34.88-81.9zm-112 160L47.96 224H271.1l-112 112z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }